export default {
  header: 'Unsaved changes',
  message: 'Your changes will be lost. Do you still want to exit?',
};
